import { get } from "lodash";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class Notification {
  static addSuccess(message, extraConfig = {}) {
    const defaultConfig = { className: "toast-dark-green-bg toast-rounded" };
    return toast.success(message, { ...defaultConfig, ...extraConfig });
  }

  static addError(message, extraConfig = {}) {
    const defaultConfig = { className: "toast-dark-red-bg toast-rounded" };
    return toast.error(message, { ...defaultConfig, ...extraConfig });
  }

  static addWarning(message, extraConfig = {}) {
    const defaultConfig = { className: "toast-rounded" };
    return toast.warn(message, { ...defaultConfig, ...extraConfig });
  }

  static addInfo(message, extraConfig = {}) {
    const defaultConfig = { className: "toast-rounded" };
    return toast.info(message, { ...defaultConfig, ...extraConfig });
  }

  static update(notificationId, extraConfig = {}) {
    return toast.update(notificationId, extraConfig);
  }

  static handleMessage(error) {
    return get(error, "response.data.errors[0].detail", "Something went wrong!");
  }
}

const NotificationService = Object.freeze(Notification);
export default NotificationService;
